export interface ILengthConstraints {
    min?: number;
    max?: number;
}

export const validateLength = (
    value: string | undefined,
    range: ILengthConstraints,
    required = true
) => {
    if (value === undefined || value === '') {
        return !required || range.min === 0;
    }

    return (
        (range.min === undefined || value.length >= range.min) &&
        (range.max === undefined || value.length <= range.max)
    );
};
